import { getTraceTypeLabel, TraceType } from '../../common/enums/TraceType';

export class SlotType {
  constructor(private readonly value: TraceType, private readonly allowed: boolean) {}

  getValue() {
    return this.value;
  }

  getLabel() {
    return getTraceTypeLabel(this.value);
  }

  isAllowed() {
    return this.allowed;
  }
}
